// Корень перекрытия (Modal, RightDrawer, ModalShell): верхнее — в <body>.
//
// Окно, отрисованное на месте, живёт в контексте наложения своего предка: его
// z-50 действует только внутри предка. Кнопка «Поделиться» сидит в панели
// ввода чата (`sticky … z-10`), и окно оказалось НИЖЕ шапки приложения (z-20)
// и нижней навигации (z-30): на телефоне шапка закрывала его заголовок с ✕,
// навигация — кнопку «Отправить», а нажатия уходили в них (скрин владельца
// 06.10.2026, iPhone). Профиль и «Новый клиент» уже чинились так поштучно —
// здесь это сделано для всех окон сразу.
//
// ВЛОЖЕННОЕ окно (абонемент поверх карточки клиента) остаётся на месте, внутри
// родителя: тот уже в <body> со своим z-50, а стек Esc (`lib/overlay-stack`)
// считает верхним того, кто вложен в другого по DOM. Унеси вложенное окно в
// <body> — оно встало бы в документе РАНЬШЕ родителя (React вставляет порталы
// детей первыми), и Esc закрывал бы родителя, оставляя окно висеть.
import { createContext, useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Класс корня перекрытия. Печать листа (афиша, ведомость) прячет приложение
 * через `#root`, а окно теперь вне него — правило печати в globals.css прячет
 * и его, иначе затемнение и сама модалка легли бы на бумагу поверх листа.
 */
export const OVERLAY_ROOT_CLASS = 'app-overlay';

const InsideOverlay = createContext(false);

export function OverlayRoot({ children }: { children: ReactNode }): JSX.Element {
  const nested = useContext(InsideOverlay);
  const content = <InsideOverlay.Provider value>{children}</InsideOverlay.Provider>;
  return nested ? content : createPortal(content, document.body);
}
